import { createAsyncThunk } from "@reduxjs/toolkit"
import { get, patch, post } from "helpers/api_helper"
import { USER_DETAILS } from "helpers/url_helper"

export const loginUser = createAsyncThunk("auth/login", async payload => {
  const response = await post("auth/login", payload)
  return response
})

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async payload => {
    const response = await post("auth/forgot-password", payload)
    return response
  }
)

export const verifyOtp = createAsyncThunk("auth/verifyOtp", async payload => {
  const response = await post("auth/verify-otp", payload)
  return response
})

export const verifyLoginOtp = createAsyncThunk(
  "auth/verifyLoginOtp",
  async payload => {
    const response = await post("auth/verify-login-otp", payload)
    return response
  }
)

export const resendLoginOtp = createAsyncThunk(
  "auth/resendLoginOtp",
  async payload => {
    const response = await post("auth/resend-login-otp", payload)
    return response
  }
)

export const resendForgotPasswordOtp = createAsyncThunk(
  "auth/resendForgotPasswordOtp",
  async payload => {
    const response = await post("auth/resend-forgot-otp", payload)
    return response
  }
)

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async payload => {
    const response = await patch("auth/reset-password", payload)
    return response
  }
)

export const userDetails = createAsyncThunk(USER_DETAILS, async payload => {
  const response = await get(USER_DETAILS)
  return response
})
